import axios from 'axios'
import  { checkErrorData } from './authAction'
import  { formatList } from './format'

export function newBank(data) {
    return async function(dispatch){
        try{
            dispatch({ type: "CREATE_BANK_START", payload: "" })
            console.log("new Bank START", {data})
            const res = await axios.post('/banks/new',{data})
            console.log({res});

            if(checkErrorData(res, "CREATE_BANK_ERROR", dispatch ) ) {
                dispatch({ type: "NEW_BANK", payload: res.data })
				dispatch({ type: "CREATE_BANK_FULFILLED", payload: "" })
            }
            
        } catch(err) {
            console.log("[ERROR] new bank ", err);
            dispatch({
                type: "CREATE_BANK_ERROR",
                payload: err
            })
        }
    }
}

export function fetchBanks() {
    return async function(dispatch){
        try{
            dispatch({ type: "FETCH_BANKS_START", payload: "" })

            console.log("fetch Bank START")
            const res = await axios.get('/banks/get/all')
            console.log({res});
            
            if(checkErrorData(res, "FETCH_BANKS_ERROR", dispatch ) ) {
				dispatch({
                    type: "GET_BANKS",
                    payload: formatList(res.data, "bank_id")
                })
				dispatch({ type: "FETCH_BANKS_FULFILLED", payload: "" })
			}
        } catch(err) {
            console.log("[ERROR] get banks list ", err);
        }
    }
}


export function updateBank(data) {
    return async function(dispatch){
        try{
            dispatch({ type: "UPDATE_BANK_START", payload: "" })

            console.log("update Bank START")
            const res = await axios.post("/banks/update", {data})
            console.log({res});

            if(checkErrorData(res, "UPDATE_BANK_ERROR", dispatch ) ) {
                
				dispatch({
                    type: "UPDATE_BANK",
                    payload: data
                })
				dispatch({ type: "UPDATE_BANK_FULFILLED", payload: "" })
			}
        } catch(err) {
            console.log("[ERROR] update bank ", err);
            dispatch({
                type: "UPDATE_BANK_ERROR",
                payload: err
                
            })
        }
    }
}
